export const PII_PATTERNS_KEY = [
  // --- Auth / Secrets ---
  /\b(pass(word|phrase)?)\b/i,
  /\b(secret|api[-_]?key|key)\b/i,
  /\b(token|access[-_]?token|id[-_]?token|refresh[-_]?token)\b/i,
  /\b(auth(entication|orization)?|bearer)\b/i,
  /\b(cookie|set[-_]?cookie|session|csrf)\b/i,

  // --- Financial (PCI DSS) ---
  /\b(card[-_]?number|credit[-_]?card|cc[-_]?number|pan)\b/i,
  /\b(cvv|cvc|security[-_]?code)\b/i,
  /\b(expiry|exp[-_]?date|exp[-_]?month|exp[-_]?year)\b/i,
  /\b(iban|account[-_]?number|routing[-_]?number|bin|swift|bic)\b/i,

  // --- Payment Gateway Specific ---
  /\b(payer(_|-)?(id|email|name|phone|bank)?)\b/i,
  /\b(payee(_|-)?(id|email|name|phone|bank)?)\b/i,
  /\b(recipient|receiver)\b/i,
  /\b(merchant(_|-)?(account|number)?)\b/i,
  /\b(customer(_|-)?(id|email|phone)?)\b/i,
  /\b(account(_|-)?(id|ref|number)?)\b/i,
  /\b(transaction(_|-)?id|txn(_|-)?id|payment(_|-)?id|invoice(_|-)?id|order(_|-)?id|checkout(_|-)?id|session(_|-)?id)\b/i,
  /\b(billing(_|-)?(address|zip|postal|country))\b/i,
  /\b(shipping(_|-)?(address|name|zip|phone))\b/i,
  /\b(beneficiary(_|-)?(id|name|account|number|bank)?)\b/i, // beneficiary fields

  // --- Identity / PII ---
  /\b(ssn|sin|nin|tax[_-]?id|national[_-]?id)\b/i,
  /\b(passport(_|-)?number?)\b/i,
  /\b(driver[_-]?license|license[_-]?number)\b/i,
  /\b(dob|birth[_-]?date)\b/i,
  /\b(phone|mobile|cell)\b/i,
  /\b(address|street|zip(code)?|postal(code)?|post[_-]?code)\b/i,

  // --- Health (if applicable) ---
  /\b(medical|patient|diagnosis|treatment|insurance|policy[_-]?number)\b/i,
] as RegExp[];

export const PII_PATTERNS_VALUE = [
  // --- Generic patterns (values) ---
  /\b\d{13,19}\b/, // Credit card PAN
  /\b\d{3,4}\b(?=\D|$)/, // CVV/CVC
  /\+?\d{7,15}/, // Phone number
  /\b\d{3}-\d{2}-\d{4}\b/, // US SSN
] as RegExp[];
